import React from "react";

const FormSubmitButton = ({ form }) => {
  return (
    <div className="sm:col-span-2">
      <input type="hidden" name="bot-field" />
      <input type="hidden" name="form-name" value={form} />
      <button
        type="submit"
        className="cursor-pointer inline-flex justify-center items-center px-5 py-3 line-crop font-display text-white uppercase transition duration-300 text-lg !leading-tight bg-red hover:bg-darkred"
      >
        Submit
        <i className="fas fa-chevron-right cursor-pointer ml-3 text-xs inline"></i>
      </button>
    </div>
  );
};

export default FormSubmitButton;
